// Module
var code = "<h2 id=\"interest\">Interest</h2> <p>Understand how interest works and how it affects the amount of your loan payments.</p> ";
// Exports
export default code;